<template>
  <v-container
    id="home"
    class="pa-0"
    fluid
    tag="section"
  >
    <hero
      class="text-center white--text align-center"
      height="30vh"
    >
      <h1 class="display-2">
        The Works of Paul Lowe
      </h1>
    </hero>

    <v-responsive
      class="mx-auto"
      max-width="1280"
    >
      <v-container>
        <v-row>
          <v-col
            v-for="(gallery, i) in galleries"
            :key="i"
            class="d-flex"
            cols="12"
            md="4"
          >
            <gallery-card :gallery="gallery" />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </v-container>
</template>

<script>
  export default {
    name: 'Home',

    components: {
      GalleryCard: () => import('./components/GalleryCard'),
      Hero: () => import('./components/Hero'),
    },

    data: () => ({
      galleries: [],
    }),
    created () {
      this.getGalleries()
    },
    methods: {
      getGalleries () {
        this.$http.get(this.$config.api + '/gallery').then(response => {
          return response.json()
        }).then(jsonData => {
          this.galleries = jsonData
        })
      },
    },
  }
</script>
